module.exports = __webpack_public_path__ + "static/media/ht.0b0aa8f9.svg";